import BaseStore from '../BaseStore';
import SystemModel from "../../models/SystemConfiguration/SystemModel";
import { observable } from 'mobx';

class SystemStore extends BaseStore {

  @observable config = {};

  constructor(transportLayer) {
    super(SystemModel, transportLayer);
  }

  fetchConfig() {
    return this.transportLayer.fetchAll().then(res => {
      res.id = 1;
      this.updateItemFromServer(res);
      return res;
    })
  }

  updateConfig(config) {
    return this.transportLayer.create(config)
  }
}

export default SystemStore;


// WEBPACK FOOTER //
// ./src/stores/SystemConfiguration/SystemStore.js